import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import DataTable from "react-data-table-component";
import Constants from "../../../../common/CustomerConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import UploadModal from "../Common/UploadModal";
import UploadDataViewModal from "../Common/UploadDataViewModal";
import toast from "react-hot-toast";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import BulkUploadFilter from "./BulkUploadFilter";
import { getCashExpenses } from "../../../../redux/feature/customer_app/customerSlice";
import ExpensesModel from "../bulck_upload/ExpensesModel";
import DownloadExcelTemplate from "../Common/DownloadExcelTemplate";

const CashExpensesList = () => {
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Finance");
  localStorage.setItem("submenu", "Cash Expenses");
  let cashDataTable = useSelector(
    (state) => state?.customer?.cashExpenses?.pagination
  );

  let cashData = useSelector((state) => state?.customer?.cashExpenses);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);

  // File Upload
  const [uploadedFile, setUploadedFile] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [parsedData, setParsedData] = useState([]);
  const [showDataModal, setShowDataModal] = useState(false);
  const [modalCashRequestShowStatus, setModalCashRequestShowStatus] =
    useState(false);

  const handleUploadComplete = async ({ jsonData, file }) => {
    const enrichedData = await Promise.all(
      jsonData.map(async (row) => {
        let customerName = "";
        try {
          const obj1 = {
            queryName: "getCustomerName",
            documentNumber: row.customerCode,
          };
          const custRes = await ItemServiceV2.generateCustomerQuery(obj1);
          if (custRes?.status === 200 && custRes?.data?.length > 0) {
            customerName = custRes.data[0].organisationName;
          }
        } catch (err) {
          console.error("Error fetching customer name", err);
        }

        let companyName = "";
        try {
          const obj2 = {
            queryName: "getCompanyName",
            companyCode: row.companyCode,
          };
          const compRes = await ItemServiceV2.generateCustomerQuery(obj2);
          if (compRes?.status === 200 && compRes?.data?.length > 0) {
            companyName = compRes.data[0].companyCodeDesc;
          }
        } catch (err) {
          console.error("Error fetching company name", err);
        }

        return {
          ...row,
          customerCodeDesc: customerName,
          companyCodeDesc: companyName,
        };
      })
    );

    setParsedData(enrichedData);
    setUploadedFile(file);
    setShowDataModal(true);
  };

  const [filterShow, setFilterShow] = useState(false);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  let cumulative = 0;
  const parseAmount = (value) => {
    if (!value) return 0;
    return (
      parseFloat(
        value
          .toString()
          .replace(/[,\r\n]/g, "")
          .trim()
      ) || 0
    );
  };

  // eslint-disable-next-line
  const enhancedData = data.flatMap((row) => {
    if (!Array.isArray(row.items)) return [];

    return row.items.map((item) => {
      const credit = parseAmount(item.creditAmount || item.poTotalNetValue);
      const debit = parseAmount(item.debitAmount || item.withdrawDebit);
      const net = credit - debit;

      cumulative += net;

      return {
        ...row,
        ...item,
        cumulative,
      };
    });
  });

  const formatSlNo = (n, prefix = "V", width = 4) => {
    const numStr = String(n);
    const padded = numStr.padStart(Math.max(width, numStr.length), "0");
    return `${prefix}${padded}`;
  };
  const generateVouchNumber = async () => {
    const obj = { sequenceName: "VOUCHER" };

    try {
      const res = await ItemServiceV2.newSequenceNumber(obj);

      // Case 1: if your service returns axios-style { status, data }
      if (res?.status === 200 && res.data?.sequenceNo) {
        // console.log(">> New Sequence Number:", res.data.sequenceNo);
        return res.data.sequenceNo;
      }

      // Case 2: if it directly returns { sequenceNo }
      if (res?.sequenceNo) {
        // console.log(">> New Sequence Number:", res.sequenceNo);
        return res.sequenceNo;
      }

      console.error(">> Error: Invalid sequence response", res);
      return null;
    } catch (error) {
      console.error("Error generating voucher number", error);
      return null;
    }
  };
  //new handle save
  const handleSave = async () => {
    const allPayloads = [];

    setDisabled(true);
    setLoading(true);

    try {
      for (const item of parsedData) {
        // 🔹 Call API for each item to get a unique sequence number
        const sequenceNo = await generateVouchNumber();
        if (!sequenceNo) {
          toast.error("Failed to generate voucher number");
          return;
        }

        const voucherNumber = formatSlNo(sequenceNo);
        const credit = parseFloat(item.creditAmount || 0);
        const debit = parseFloat(item.debitAmount || 0);
        const type = item.type;

        let originalPayload, reversePayload;

        if (type === "DEBIT") {
          // Company pays (Salary, Expense, etc.)
          originalPayload = {
            data: {
              slNo: voucherNumber,
              voucherNumber,
              companyCode: item.companyCode,
              companyCode2: "",
              companyCodeDesc: item.companyCodeDesc,
              customerCodeDesc: item.customerCodeDesc,
              transaction: "Payment",
              transactionType: "EK",
              customerCode: "",
              bankName: item.companyBankName,
              customerBank: item.customerBank,
              companyBank: item.companyBank,
              transactionMode: item.transactionMode,
              bankTransactionDate: item.bankTransactionDate,
              partyCode: item.partyCode,
              remarks: item.remarks,
              type: "CREDIT", // company credited
              expensesHead: item.expensesHead,
              items: [
                {
                  slNo: "1",
                  creditAmount: debit, // company credited
                  debitAmount: 0,
                  transaction: "Payment",
                },
              ],
              documentNumber: item.documentNumber,
              invoiceNr: item.invoiceNr,
              invoiceStatusHeader: item.invoiceStatusHeader,
              createdBy: item.createdBy,
              createdByName: item.createdByName,
              createdAt: item.createdAt,
              updatedAt: item.updatedAt,
            },
          };

          reversePayload = {
            data: {
              slNo: voucherNumber,
              voucherNumber,
              companyCode: "",
              companyCode2: item.companyCode,
              companyCodeDesc: item.companyCodeDesc,
              customerCodeDesc: item.customerCodeDesc,
              transaction: "Receipt",
              transactionType: "EK",
              customerCode: item.customerCode,
              bankName: item.customerBankName,
              customerBank: item.customerBank,
              companyBank: item.companyBank,
              transactionMode: item.transactionMode,
              bankTransactionDate: item.bankTransactionDate,
              partyCode: item.partyCode,
              remarks: item.remarks,
              type: "DEBIT", // driver debited
              expensesHead: item.expensesHead,
              items: [
                {
                  slNo: "1",
                  creditAmount: 0,
                  debitAmount: debit, // driver receives
                  transaction: "Receipt",
                },
              ],
              documentNumber: item.documentNumber,
              invoiceNr: item.documentNumber,
              invoiceStatusHeader: item.invoiceStatusHeader,
              createdBy: item.createdBy,
              createdByName: item.createdByName,
              createdAt: item.createdAt,
              updatedAt: item.updatedAt,
            },
          };
        } else if (type === "CREDIT") {
          // Customer pays (Income, Receipt, etc.)
          originalPayload = {
            data: {
              slNo: voucherNumber,
              voucherNumber,
              companyCode: "",
              companyCode2: item.companyCode,
              companyCodeDesc: item.companyCodeDesc,
              customerCodeDesc: item.customerCodeDesc,
              transaction: "Receipt",
              transactionType: "EK",
              customerCode: item.customerCode,
              bankName: item.customerBankName,
              customerBank: item.customerBank,
              companyBank: item.companyBank,
              transactionMode: item.transactionMode,
              bankTransactionDate: item.bankTransactionDate,
              partyCode: item.partyCode,
              remarks: item.remarks,
              type: "DEBIT", // driver debited
              expensesHead: item.expensesHead,
              items: [
                {
                  slNo: "1",
                  creditAmount: 0,
                  debitAmount: credit, // driver receives
                  transaction: "Receipt",
                },
              ],
              documentNumber: item.documentNumber,
              invoiceNr: item.documentNumber,
              invoiceStatusHeader: item.invoiceStatusHeader,
              createdBy: item.createdBy,
              createdByName: item.createdByName,
              createdAt: item.createdAt,
              updatedAt: item.updatedAt,
            },
          };

          reversePayload = {
            data: {
              slNo: voucherNumber,
              voucherNumber,
              companyCode: item.companyCode,
              companyCode2: "",
              companyCodeDesc: item.companyCodeDesc,
              customerCodeDesc: item.customerCodeDesc,
              transaction: "Payment",
              transactionType: "EK",
              customerCode: "",
              bankName: item.companyBankName,
              customerBank: item.customerBank,
              companyBank: item.companyBank,
              transactionMode: item.transactionMode,
              bankTransactionDate: item.bankTransactionDate,
              partyCode: item.partyCode,
              remarks: item.remarks,
              type: "CREDIT", // company credited
              expensesHead: item.expensesHead,
              items: [
                {
                  slNo: "1",
                  creditAmount: credit, // company credited
                  debitAmount: 0,
                  transaction: "Payment",
                },
              ],
              documentNumber: item.documentNumber,
              invoiceNr: item.invoiceNr,
              invoiceStatusHeader: item.invoiceStatusHeader,
              createdBy: item.createdBy,
              createdByName: item.createdByName,
              createdAt: item.createdAt,
              updatedAt: item.updatedAt,
            },
          };
        }

        if (originalPayload) allPayloads.push(originalPayload);
        if (reversePayload) allPayloads.push(reversePayload);
      }

      const failedEntries = [];

      for (const payload of allPayloads) {
        const response = await ItemServiceV2.addInvoice(payload);
        if (!response || response.status !== 200) {
          failedEntries.push(
            payload.data.companyCodeDesc || payload.data.companyCode
          );
        }
      }

      if (failedEntries.length === 0) {
        toast.success("All bank statements uploaded successfully", {
          duration: 3000,
          position: "top-right",
        });
        dispatch(
          getCashExpenses({
            queryName: "Customer_BankAndExpenses_List",
            transactionType: "EK",
          })
        );
        setShowDataModal(false);
      } else {
        toast.error(`Failed to upload for: ${failedEntries.join(", ")}`, {
          duration: 5000,
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Something went wrong during upload", {
        duration: 5000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
      setLoading(false);
    }
  };
  const CashUploadColumns = [
    {
      name: "Company",
      id: "companyCode",
      selector: (row) => row.companyCode,
      cell: (row) => (
        <div>
          <p className="">{row.companyCodeDesc || "--"}</p>
          {row.companyCode || "--"}
          <p></p>
        </div>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Company Bank",
      selector: (row) => row.companyBankName,
      sortable: true,
      width: "140px",
    },

    {
      name: "Customer",
      cell: (row) => (
        <div className="d-flex flex-column">
          <p className="m-0 fw-bold"> {row.customerName} </p>
          <p className="m-0"> {row.customerCodeDesc} </p>
        </div>
      ),
      width: "160px",
    },

    {
      name: "Customer Bank",
      selector: (row) => row.customerBankName,
      sortable: true,
      width: "140px",
    },
    {
      name: "Expenses",
      selector: (row) => row.expensesHead,
      sortable: true,
      width: "140px",
    },

    {
      name: "Transaction Mode",
      selector: (row) => row.transactionMode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction Date",
      selector: (row) => row.bankTransactionDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction Type",
      selector: (row) => row.type,
      sortable: true,
      width: "180px",
      cell: (row) => {
        const parseAmount = (val) =>
          parseFloat((val || "0").toString().replace(/,/g, ""));

        const credit = parseAmount(row.creditAmount);
        const debit = parseAmount(row.debitAmount);

        let displayType = "Invalid";
        // let badgeClass = "bg-table-status bg-table-warning-status";

        if (credit > 0 && debit === 0) {
          displayType = "Credit";
          // badgeClass = "bg-table-status bg-table-success-status";
        } else if (debit > 0 && credit === 0) {
          displayType = "Debit";
          // badgeClass = "bg-table-status bg-table-danger-status";
        }
        return <span>{displayType}</span>;
      },
    },

    {
      name: "Remarks",
      selector: (row) => row.remarks,
      sortable: true,
      width: "180px",
    },
    {
      name: "Debit",
      selector: (row) => row.debitAmount,
      sortable: true,
      width: "150px",
      // right: true,
    },
    {
      name: "Credit",
      selector: (row) => row.creditAmount,
      sortable: true,
      width: "150px",
      // right: true,
    },
  ];
  const cashRow = [
    {
      name: "Transaction Nr",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status">
          {row.documentNumber}
        </span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Voucher Nr",
      selector: (row) => row?.voucherNumber,
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status">
          {row.voucherNumber || "--"}
        </span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCode",
      selector: (row) => row.companyCode,
      cell: (row) => (
        <div>
          <p className="fw-bold">{row.companyCodeDesc || "--"}</p>
          {row.companyCode || "--"}
          <p></p>
        </div>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Customer/Employee",
      selector: (row) => row.customerCode,
      cell: (row) => (
        <div>
          <p className="fw-bold">{row.customerCodeDesc || "--"}</p>
          <p>{row.customerCode || "--"}</p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Expenses",
      selector: (row) => row.expensesHead,
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction Mode",
      selector: (row) => row.transactionMode,
      cell: (row) => <p className="fw-bold">{row.transactionMode}</p>,
      sortable: true,
      width: "160px",
    },
    {
      name: "Transaction Date",
      selector: (row) => row.bankTransactionDate,
      sortable: true,
      width: "160px",
    },

    {
      name: "Remarks",
      selector: (row) => row.remarks,
      cell: (row) => <p>{row.remarks}</p>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction",
      selector: (row) => row.transaction,
      cell: (row) => (
        <span className="bg-table-status bg-table-progress-status">
          {row.transaction}
        </span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction Type",
      selector: (row) => row.type,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <span
          className={`bg-table-status ${
            row.type === "DEBIT"
              ? "bg-table-danger-status"
              : row.type === "CREDIT"
              ? "bg-table-success-status"
              : ""
          }`}
        >
          {row.type}
        </span>
      ),
    },
    {
      name: "Debit",
      selector: (row) => row.items?.[0]?.debitAmount,
      cell: (row) => (
        <span
          className="bg-table-status bg-table-danger-status"
          style={{ padding: "4px 10px", borderRadius: "10px" }}
        >
          ₹{" "}
          {row.items?.[0]?.debitAmount
            ? row.items[0].debitAmount.toLocaleString("en-IN")
            : "0"}
        </span>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Credit",
      selector: (row) => row.items?.[0]?.creditAmount,
      cell: (row) => (
        <span
          className="bg-table-status bg-table-success-status"
          style={{ padding: "4px 10px", borderRadius: "10px" }}
        >
          ₹{" "}
          {row.items?.[0]?.creditAmount
            ? row.items[0].creditAmount.toLocaleString("en-IN")
            : "0"}
        </span>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "CompanyCode2",
      selector: (row) => row.items?.[0]?.companyCode2,
      cell: (row) => <span>{row.companyCode2 || "--"}</span>,
      sortable: true,
      width: "150px",
    },
  ];
  const handlePageChange = (page) => {
    let obj = {
      queryName: "Customer_BankAndExpenses_List",
      page: page,
      transactionType: "EK",
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getCashExpenses(obj));
    setData(cashData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Customer_BankAndExpenses_List",
      page: 1,
      transactionType: "EK",
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getCashExpenses(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Customer_BankAndExpenses_List",
      page: page,
      transactionType: "EK",
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getCashExpenses(obj));
    setData(cashData?.data);
  };

  const loadInitialPOData = async () => {
    setData(cashData?.data);
  };

  useEffect(() => {
    loadInitialPOData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Customer_BankAndExpenses_List",
      module: "CUSTOMER",
      transactionType: "EK",
      page: 1,
      per_page: 10,
    };
    dispatch(getCashExpenses(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "Customer_BankAndExpenses_List",
      module: "CUSTOMER",
      page: 1,
      transactionType: "EK",
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    dispatch(getCashExpenses(obj));
  };
 // eslint-disable-next-line 
  const showCashRequestModal = () => {
    setModalCashRequestShowStatus(true);
  };
  const hideModalStatus = () => {
    setModalCashRequestShowStatus(false); //hide cash request modal
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Cash Expenses</h2>
                <p className="subText">Lists of Cash Expenses and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />

            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <BulkUploadFilter
                    getfiltereddata={cashRow}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>

                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CE</span>
                    </Col>

                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Cash Expenses</span>
                      <span className="subHeaderTitle">
                        View of Cash Expenses and Status
                      </span>
                    </Col>
                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      {/* <Col xs={6} md={6} lg={7} className="me-2">
                        <button
                          className="btnTable"
                          onClick={() => showCashRequestModal()}
                        >
                          Expenses
                        </button>
                      </Col> */}
                      <Col xs={6} md={6} lg={7} className="me-2">
                        <DownloadExcelTemplate type="CASHSTATMENT" />
                      </Col>

                      <Col xs={6} md={6} lg={7} className="me-2">
                        <button
                          className="btnTable"
                          onClick={() => setShowUploadModal(true)}
                        >
                          <i className="bi bi-upload px-2"></i>
                          Upload
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <StickyColumn columnIndexes={[1]} leftOffsets={[0]} />
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={cashRow}
                          data={data}
                          progressPending={cashData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={cashDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRowss
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <UploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onUploadComplete={handleUploadComplete}
      />

      <UploadDataViewModal
        show={showDataModal}
        onHide={() => setShowDataModal(false)}
        data={parsedData}
        columns={CashUploadColumns}
        title="Uploaded Cash Expenses"
        file={uploadedFile}
        onClick={handleSave}
        disabled={disabled}
        loading={loading}
      />
      <ExpensesModel
        show={modalCashRequestShowStatus}
        onHide={() => hideModalStatus()}
      />
    </main>
  );
};

export default CashExpensesList;
